<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div *ngIf="!paymentRequest.specificPaymentMethod" class="banner">
      <button type="button" class="back-button" (click)="reroute()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <div class="page-icon">
          <app-zaver-icon [size]="80" name="userCircle" ></app-zaver-icon>
        </div>

        <div class="page-text">
          Ange ditt personnummer för att fortsätta betalningen.
        </div>

        <form [formGroup]="form">
          <div class="input-container">
            <zaver-animated-form-input
              [size]="'large'"
              [ariaLabel]="'Ange personnummer'"
              [formControlName]="'pnr'"
              [error]="form.controls.pnr.invalid && showError"
              inputMode="numeric"
              placeholder="ååååmmddnnnn"
              errorMessage="Vänligen ange ett giltigt personnummer"
              [errorIcon]="'assets/icon/icon_error.svg'"
            ></zaver-animated-form-input>
          </div>
        </form>

        <div class="footer-wrapper">
          <div class="footer-container">
            <div class="pr-info" *ngIf="paymentRequest">
              <label>Totalbelopp</label>
              <label>
                {{
                  paymentRequest.amount.toLocaleString('sv', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
                }}
                {{ paymentRequest.currency }}
              </label>
            </div>

            <zaver-primary-button text="Välj din bank" (click)="continue()">
            </zaver-primary-button>

            <app-se-terms
              *ngIf="!!paymentRequest.specificPaymentMethod"
              [paymentRequest]="paymentRequest"
            ></app-se-terms>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
